import React from 'react'
import Modal from '../../modal'
import CloseSVG from '../../../../assets/svg/close.svg'

const TestScore = ({ isOpen, closeModal, testResponse }) => {
  return (
    <Modal
      scrollable={true}
      className='!w-[500px]'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        <div className='px-4 pt-3'>
          <div className='flex flex-row justify-between items-center'>
            <span className='header-4'>Test Result</span>
            <button onClick={() => closeModal()}>
              <img src={CloseSVG} alt='close' />
            </button>
          </div>
        </div>
        <hr className='divider mb-2' />
        <main className='mx-4 flex flex-col items-center justify-center gap-2'>
          <h1 className='text-base font-medium'>Test completed</h1>
          <p className='text-sm font-medium'>Your Score</p>
          <h1
            className={`text-[40px] font-semibold ${
              testResponse?.correct >= parseInt(testResponse?.passing_grade)
                ? 'text-[#2cb629]'
                : 'text-red-500'
            }`}
          >
            {testResponse?.correct}/{testResponse?.total}
          </h1>
          <h1 className='text-base font-medium'>Feedback</h1>
          {testResponse?.correct >= parseInt(testResponse?.passing_grade) ? (
            <p className='text-sm font-medium pb-3'>
              {`You passed the test having met the pass mark.`}
            </p>
          ) : (
            <p className='text-sm font-medium pb-3'>{`You failed the test.`}</p>
          )}
        </main>
      </div>
    </Modal>
  )
}

export default TestScore
